"use client";

import React from "react";
import { MapPin, Phone, Mail, Building2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const CONTACT_INFO = {
  address: "Global Cloud & AI Advisory - Remote & On-Site Worldwide",
  phone: "+1 (703) 216-6676",
  email: "david@davidlinthicum.com",
  hours: "Mon - Fri: 08:00 - 17:00 EST"
};
export default function StartAConversation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222095" id="start-a-conversation" className="py-24 bg-background text-foreground relative overflow-hidden" ref={ref}>
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <span className="text-[40rem] font-bold font-default text-primary opacity-[0.03] leading-none tracking-tighter">
          DSL
        </span>
      </div>
      
      <div className="absolute top-0 left-0 w-full h-[500px] bg-gradient-to-b from-accent/20 to-transparent -z-10" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className={`flex flex-col items-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary/10 border border-primary/20 text-primary text-xs font-mono uppercase tracking-widest mb-6">
              <Building2 className="size-4" />
              <span>Direct Access</span>
            </div>
            <h2 className="text-4xl md:text-6xl font-bold font-default text-foreground tracking-tighter mb-4">
              Start a Conversation
            </h2>
            <p className="text-xl text-muted-foreground leading-relaxed font-default max-w-2xl mx-auto">
              Connect with David Scott Linthicum for strategic AI advisory, cloud architecture mentoring, high-impact speaking engagements, and tech marketing content.
            </p>
          </div>

          <div className="w-full max-w-2xl space-y-6">
            <div className="bg-card/50 backdrop-blur-xl rounded-md p-8 border border-border shadow-xl h-full flex flex-col justify-between">
              <div className="space-y-8">
                <div className="flex gap-4">
                  <div className="size-10 rounded-md bg-primary/10 flex items-center justify-center shrink-0">
                    <MapPin className="size-5 text-primary" />
                  </div>
                  <div>
                    <h4 className="font-mono text-xs uppercase tracking-widest text-primary mb-1">Location</h4>
                    <p className="text-foreground font-default">{CONTACT_INFO.address}</p>
                  </div>
                </div>

                <Link to={`tel:${CONTACT_INFO.phone}`} className="flex gap-4 group hover:opacity-80 transition-opacity">
                  <div className="size-10 rounded-md bg-primary/10 flex items-center justify-center shrink-0 group-hover:bg-primary/20 transition-colors">
                    <Phone className="size-5 text-primary" />
                  </div>
                  <div>
                    <h4 className="font-mono text-xs uppercase tracking-widest text-primary mb-1">Direct Line</h4>
                    <p className="text-foreground font-default">{CONTACT_INFO.phone}</p>
                  </div>
                </Link>

                <Link to={`mailto:${CONTACT_INFO.email}`} className="flex gap-4 group hover:opacity-80 transition-opacity">
                  <div className="size-10 rounded-md bg-primary/10 flex items-center justify-center shrink-0 group-hover:bg-primary/20 transition-colors">
                    <Mail className="size-5 text-primary" />
                  </div>
                  <div>
                    <h4 className="font-mono text-xs uppercase tracking-widest text-primary mb-1">Email</h4>
                    <p className="text-foreground font-default">{CONTACT_INFO.email}</p>
                  </div>
                </Link>

              </div>

              <div className="mt-12 pt-8 border-t border-border">
                <p className="text-sm text-muted-foreground italic text-center">
                  "Strategic clarity in the age of AI complexity starts with a single dialogue."
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}